import React, { useState } from 'react';
import seaFreightImg from '../assets/img/service-sea freight.png';
import airFreightImg from '../assets/img/service-air freight.png';
import roroImg from '../assets/img/service-road feeder service.png';
import warehousingImg from '../assets/img/service-warehouse solutions.png';
import customsImg from '../assets/img/service-customs clearance.png';
import projectCargoImg from '../assets/img/service-project cargo.png';
import scmImg from '../assets/img/SCM.jpg';

function Services() {
  const [selectedService, setSelectedService] = useState(null);

  const services = [
    {
      id: 1,
      title: "Sea Freight",
      description: "Reliable and cost-effective ocean shipping solutions tailored to your needs.",
      image: seaFreightImg,
      details: "Our sea freight services offer flexible and cost-effective solutions for various cargo types, ensuring timely and secure delivery across global trade routes."
    },
    {
      id: 2,
      title: "Air Freight",
      description: "Fast and secure air cargo services ensuring timely delivery.",
      image: airFreightImg,
      details: "We provide fast and reliable air freight services, leveraging a vast network of airlines to meet your urgent shipping needs."
    },
    {
      id: 3,
      title: "RoRo (Roll-on/Roll-off) Services",
      description: "Efficient transportation for vehicles and rolling cargo.",
      image: roroImg,
      details: "Our Roll-on/Roll-off services are designed for the efficient transportation of vehicles and rolling cargo, minimizing handling time and reducing risk."
    },
    {
      id: 4,
      title: "Warehousing & Distribution",
      description: "Safe and organized storage with efficient distribution networks.",
      image: warehousingImg,
      details: "With strategically located warehouses, we offer secure storage solutions, inventory management, and order fulfillment services to streamline your supply chain."
    },
    {
      id: 5,
      title: "Customs Brokerage",
      description: "Expert handling of import/export documentation and compliance.",
      image: customsImg,
      details: "Our experienced customs brokers ensure compliance with all import/export regulations, facilitating smooth and timely clearance of your goods."
    },
    {
      id: 6,
      title: "Project Cargo Handling",
      description: "Tailored solutions for oversized and heavy shipments.",
      image: projectCargoImg,
      details: "We specialize in managing complex logistics for oversized and heavy cargo, providing tailored solutions to meet specific project requirements."
    },
    {
      id: 7,
      title: "Supply Chain Management",
      description: "End-to-end logistics solutions optimizing your supply chain.",
      image: scmImg,
      details: "Our end-to-end supply chain solutions encompass procurement, transportation, warehousing, and distribution, optimizing efficiency and reducing costs."
    }
  ];

  const handleSeeMore = () => {
    // Scroll to contact section or you can implement other functionality
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="section-padding bg-ash-dark">
      <div className="container-custom">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="heading-secondary mb-6">
            Our <span className="text-red">Services</span>
          </h2>
          <p className="text-xl text-gray-light max-w-3xl mx-auto">
            Comprehensive logistics solutions tailored to your business needs. 
            From freight forwarding to supply chain optimization, we've got you covered.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="bg-white/10 rounded-xl p-8 border border-white/20 hover:border-white/40 transition-all duration-300 group backdrop-blur-2xl"
            >
              {/* Service Image */}
              <div className="mb-6 rounded-lg overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <h3 className="text-xl font-semibold mb-4 text-white group-hover:text-red transition-colors">
                {service.title}
              </h3>

              <p className="text-gray-light mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* Read More Button with darker glassy effect */}
              <button
                onClick={() => setSelectedService(service)}
                className="bg-white/10 text-white hover:bg-white/20 font-medium flex items-center group px-4 py-2 rounded-lg transition-all duration-300 backdrop-blur-lg border border-white/30"
              >
                Read More
                <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          ))}
        </div>

        {/* See More Button */}
        <div className="text-center mt-12">
          <button
            onClick={handleSeeMore}
            className="btn-primary px-8 py-3 rounded-full font-semibold text-lg hover:scale-105 transition-transform duration-300"
          >
            See More Services
          </button>
        </div>
      </div>

      {/* Service Detail Modal */}
      {selectedService && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-lg z-50 flex items-center justify-center p-4">
          <div className="bg-white/10 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-white/20 backdrop-blur-2xl">
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-2xl font-bold text-white">
                  {selectedService.title}
                </h3>
                <button 
                  onClick={() => setSelectedService(null)}
                  className="text-gray-light hover:text-white"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              {/* Service Image in Modal */}
              <div className="mb-6 rounded-lg overflow-hidden">
                <img 
                  src={selectedService.image} 
                  alt={selectedService.title} 
                  className="w-full h-64 object-cover"
                />
              </div>
              
              <p className="text-gray-light leading-relaxed mb-8">
                {selectedService.details}
              </p>
              
              <div className="flex justify-end">
                <button
                  onClick={() => setSelectedService(null)}
                  className="btn-primary px-6 py-3"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Services;